import React, { useState, useEffect } from "react";
import _ from "lodash";
import pluralize from "pluralize";
import Controls from "./../../molecules/Controls";
import DeliveryExclusions from "./../../organisms/DeliveryExclusions";
import { ReactComponent as BackArrow } from "./../../atoms/icons/chevron-back.svg";
import {
  Wrap,
  Header,
  HeaderContent,
  Title,
  BackButton,
  BackLink,
  CountGeneral,
  Body,
  ButtonWrapper,
  Quantificator,
  QuantificatorItem,
  QuantificatorItemImageWrap,
  QuantificatorItemTitle,
  QuantificatorItemPrice,
  Button,
  ValidationMessage,
} from "./styles";

const getMinPurchQty = (main_title, dietType)=> {
switch (dietType) {
  case "Mediterranean Plan":
    return 6;
  case "Low-FODMAP Plan":
    return 6;
  case "Diabetes-Friendly Plan":
    return 6;
  case "Gluten-Free Plan":
    return 6;
  case "Heart-Friendly Plan":
    return 6;
  case "Carb-Conscious Plan":
    return 6;
  case "B2B Plan":
    return 6;
  case "Care Plan":
    return 1;
  case "GLP-1 Plan":
    return 6;
  default:
    return 6;
  }
}

function EditQuantity(props) {
  const {
    exclusions,
    dietType,
    editChargeId,
    handleBackClick,
    saveQuantityData,
    redirectEditQuantity,
    mealSettings,
    main_title,
    charges,
    bundles,
  } = props;
  const [breakfasts, setBreakfasts] = useState(null);
  const [entrees, setEntrees] = useState(null);
  const [selectedExclusions, setSelectedExclusions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(true);
  const [limit, setLimit] = useState(null);

  const breakfastRef = React.createRef();
  const entreeRef = React.createRef();

  const getSelectedExclusions = () => {
    const _exclusionCodes = getEsclusionCodes();
    let _selectedExclusions = [];

    let type = '';
    if (main_title === 'Low-FODMAP Plan' || main_title === 'Gluten-Free Plan' || main_title === 'Carb-Conscious Plan' || main_title === 'B2B Plan' || main_title === 'GLP-1 Plan') {
        type = 'FL-';
    } else if (main_title === 'Care Plan') {
        type = 'CM-';
    } else {
        type = 'MD-';
    }

    const exclusionCodesArray = _exclusionCodes.length ? _exclusionCodes.split(",") : [];
    const fullExcludeSku = exclusionCodesArray.map(code => type + code)

    // return exclusions.filter((item) => item.sku.includes(type));

    exclusions.forEach((element) => {
      let sku = element.sku;
      fullExcludeSku.forEach((code) => {
        if (sku.includes(code)) _selectedExclusions.push(element.name);
      });
    });

    return _selectedExclusions;
  };

  useEffect(() => {
    let newExlusions = [...selectedExclusions];
    const minPurchaseAmount = getMinPurchQty(main_title, dietType);

    newExlusions = _.concat(newExlusions, getSelectedExclusions());
    newExlusions = _.uniq(newExlusions);

    setSelectedExclusions(newExlusions);
    setLimit(minPurchaseAmount !== "undefined" ? minPurchaseAmount : 5);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleExclusionChange = (e, reference) => {
    let newExlusions = [...selectedExclusions],
      change = reference.checked === true ? "add" : "delete",
      value = e.target.value;

    if (change === "add") {
      if (newExlusions.indexOf(value) === -1) {
        newExlusions.push(value);
      } else {
        _.remove(newExlusions, (item) => item === value);
      }
    } else {
      _.remove(newExlusions, (item) => item === value);
    }

    newExlusions = _.uniq(newExlusions);

    setSelectedExclusions(newExlusions);
  };

  const getCurrentCharge = (id, chargesData) => {
    let foundCharge = {};
    if (!chargesData.length) return foundCharge;
    chargesData.forEach((charge) => {
      if (charge.id === id) foundCharge = charge;
    });
    return { ...foundCharge };
  };

  const getEsclusionCodes = () => {
    const _charges = [...charges];
    const currentCharge = getCurrentCharge(editChargeId, _charges);
    const excludeCodes = typeof currentCharge.excludeCodes === "undefined" ? "" : currentCharge.excludeCodes;

    return excludeCodes !== null ? excludeCodes : "";
  };

  const calculateQuantity = () => {
    const _charges = [...charges];

    const computeMealsQuantity = (_charge, type) => {
      let quantity = 0;
      if (!_charges.length) return quantity;
      _charge.meals.forEach((meal) => {
        if (!meal.tags.length) return quantity;
        meal.tags.forEach((tag) => {
          if (tag.toLowerCase() === type.toLowerCase()) quantity += meal.quantity;
        });
      });

      return quantity;
    };
    const breakfastsQuantity = computeMealsQuantity(getCurrentCharge(editChargeId, _charges), "Breakfast");
    const entreesQuantity = computeMealsQuantity(getCurrentCharge(editChargeId, _charges), "Entrée");

    return {
      initialBreakfasts: breakfastsQuantity,
      initialEntrees: entreesQuantity,
    };
  };

  const handleQuantityChange = (quantity, type) => {
    if (type === "breakfasts") setBreakfasts(quantity);
    if (type === "entrees") setEntrees(quantity);
  };

  const validateMinimumAmount = (summ) => {
    return summ < limit ? false : true;
  };

  const handleSaveQuantity = () => {

    let breakfastQuantity = 0;

  if(main_title === "Mediterranean Plan") { breakfastQuantity = 0 };
  if(main_title === "Low-FODMAP Plan") { breakfastQuantity = parseInt(breakfastRef.current.value)};
  if(main_title === "Diabetes Plan") { breakfastQuantity = 0 };
  if(main_title === "Gluten-Free Plan") { breakfastQuantity = parseInt(breakfastRef.current.value) };
  if(main_title === "Heart-Friendly Plan") { breakfastQuantity = 0 };
  if(main_title === "Carb-Conscious Plan") { breakfastQuantity = parseInt(breakfastRef.current.value) };
  if(main_title === "B2B Plan") { breakfastQuantity = parseInt(breakfastRef.current.value) };
  if(main_title === "Care Plan") { breakfastQuantity = parseInt(breakfastRef.current.value) };
  if(main_title === "GLP-1 Plan") { breakfastQuantity = parseInt(breakfastRef.current.value) };

    const entreeQuantity = parseInt(entreeRef.current.value);

    const data = {
      breakfasts: breakfastQuantity,
      entrees: entreeQuantity,
      selectedExclusions: [...selectedExclusions],
    };
    const summ = breakfastQuantity + entreeQuantity;

    let valid = validateMinimumAmount(summ);

    if (valid) {
      setValid(true);
      setLoading(true);
      saveQuantityData(data);
    } else {
      setValid(false);
    }
  };

  const formatPrice = (price) => {
    return `$${price} each`
  }

  const generateEntreePriceMarkup = () => {
    let currentEntreePriceMarkup = "";
    bundles.forEach((bundle) => {
      if (bundle.tags.includes("Entrees")) {
        currentEntreePriceMarkup = formatPrice(bundle.variants[0].price);
      }
    });

    return (
      <QuantificatorItemPrice
        dangerouslySetInnerHTML={{
          __html: currentEntreePriceMarkup,
        }}
      />
    );
  };

  const generateBreakfastsPriceMarkup = () => {
    let currentBreakfastsPriceMarkup = "";
    bundles.forEach(bundle => {
      if(bundle.tags.includes("Breakfasts")){
        currentBreakfastsPriceMarkup = formatPrice(bundle.variants[0].price);
      }
    });

    return (
      <QuantificatorItemPrice
        dangerouslySetInnerHTML={{
          __html: currentBreakfastsPriceMarkup,
        }}
      />
    );
  };

  const { initialBreakfasts, initialEntrees } = calculateQuantity();
  const combinedBreakfasts = breakfasts === null ? initialBreakfasts : breakfasts;
  const combinedEntrees = entrees === null ? initialEntrees : entrees;
  const totalQuantity = combinedBreakfasts + combinedEntrees;
  const exclusionCodes = getEsclusionCodes();
  const breakfastImage = mealSettings.breakfastImage;
  const entreeImage = mealSettings.entreeImage;
  const entreePriceMarkup = generateEntreePriceMarkup();
  const breakfastsPriceMarkup = generateBreakfastsPriceMarkup();

  return (
    <Wrap>
      <Header>
        <HeaderContent>
          {redirectEditQuantity && (
            <BackLink href="/pages/account-settings">
              <BackArrow />
            </BackLink>
          )}
          {!redirectEditQuantity && (
            <BackButton onClick={handleBackClick}>
              <BackArrow />
            </BackButton>
          )}

          <Title>Adjust Your Meal Quantities</Title>
          <p>
            Your current meal plan contains {pluralize("meal", totalQuantity, true)}. If desired, adjust your quantities here and click NEXT
            to proceed.
          </p>
        </HeaderContent>
        <CountGeneral>
          <span className="edit-quantity__count">
            <b>{totalQuantity}</b>
          </span>
          <span className="edit-quantity__content">{pluralize("meal", totalQuantity)} have been selected</span>
        </CountGeneral>
      </Header>
      <Body>
        <Quantificator>
          {(main_title !== "Mediterranean Plan" && main_title !== "Diabetes Plan" && main_title !== "Heart-Friendly Plan") && (
            <QuantificatorItem>
              <QuantificatorItemImageWrap>
                <img src={breakfastImage} loading="lazy" decoding="async" alt="Breakfast" />
              </QuantificatorItemImageWrap>
              <QuantificatorItemTitle>Breakfasts</QuantificatorItemTitle>
              {breakfastsPriceMarkup}
              <Controls
                quantityChange={(quantity) => {
                  handleQuantityChange(quantity, "breakfasts");
                }}
                quantitySelected={combinedBreakfasts}
                refData={breakfastRef}
              />
            </QuantificatorItem>
          )}
          <QuantificatorItem>
            <QuantificatorItemImageWrap>
              <img src={entreeImage} loading="lazy" decoding="async" alt="Entrée" />
            </QuantificatorItemImageWrap>
            {(main_title !== "Mediterranean Plan" && main_title !== "Diabetes Plan" && main_title !== "Heart-Friendly Plan") && <QuantificatorItemTitle>Entrées</QuantificatorItemTitle>}
            {(main_title === "Mediterranean Plan" || main_title === "Diabetes Plan" || main_title === "Heart-Friendly Plan") && <QuantificatorItemTitle>Meals/Week</QuantificatorItemTitle>}
            {entreePriceMarkup}
            <Controls
              quantityChange={(quantity) => {
                handleQuantityChange(quantity, "entrees");
              }}
              quantitySelected={combinedEntrees}
              refData={entreeRef}
            />
          </QuantificatorItem>
        </Quantificator>
        <DeliveryExclusions
          exclusions={exclusions}
          exclusionCodes={exclusionCodes}
          selectedExclusions={selectedExclusions}
          handleExclusionChange={handleExclusionChange}
          dietType={dietType}
          main_title={main_title}
        />
        <ButtonWrapper>
          <Button onClick={handleSaveQuantity} className={loading ? "loading" : ""} disabled={loading ? true : false}>
            <span></span>
            <b>Next</b>
          </Button>
        </ButtonWrapper>
        {!valid && <ValidationMessage>Please add a minimum of {limit} meals to your order.</ValidationMessage>}
      </Body>
    </Wrap>
  );
}

export default EditQuantity;

